// Picks the rendition the <video> element should play.
//
// Preference order: HD (when requested) → SD → ORIGINAL.
//
// ORIGINAL is the raw upload and is only a last resort. Raw HUB uploads have
// been SD-only since the backend transcode slimming (shootsta-backend-private#220),
// and a raw 4K / HEVC 10-bit camera file streamed to the browser plays audio with
// a black picture on any machine without a hardware HEVC decoder (#3834).
export const getSourceFile = ({ asset = {}, isHD }) => {
  if (!asset) {
    return {};
  }

  const { assetFiles } = asset || {};

  if (!assetFiles) {
    return {};
  }

  const { HD, SD, ORIGINAL } = assetFiles;

  if (isHD && HD) {
    return HD;
  }

  return SD || ORIGINAL || {};
};
